export default "__VITE_ASSET__D23QBG1G__"